/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './authentication-wam.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../home/home/home.component.ngfactory';
import * as i3 from '@angular/http';
import * as i4 from '../../../app/global-http-handler';
import * as i5 from '../../../app/home/home/home.component';
import * as i6 from 'ng2-toastr/src/toast-manager';
import * as i7 from '../../../app/errorhandler/gpiserror-handler.service';
import * as i8 from '../../../app/config/app.config';
import * as i9 from '@angular/common';
import * as i10 from '../../../app/authentication-wam/authentication-wam.component';
import * as i11 from '../../../app/authentication-wam/user.service';
import * as i12 from '../../../app/authentication-wam/authentication-wam.service';
import * as i13 from '@angular/router';
const styles_AuthenticationWamComponent:any[] = [i0.styles];
export const RenderType_AuthenticationWamComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AuthenticationWamComponent,data:{}});
function View_AuthenticationWamComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),
      2,'app-home',([] as any[]),[[2,'sidebar-collapsed',(null as any)],[2,'sticky-header',
          (null as any)],[2,'sidebar-open',(null as any)]],[['window','resize']],(_v,
          en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,4).onResize($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_HomeComponent_0,i2.RenderType_HomeComponent)),i1.ɵprd(512,(null as any),
      i3.Http,i4.GlobalHttpHandler,[i3.XHRBackend,i3.RequestOptions]),i1.ɵdid(49152,
      (null as any),0,i5.HomeComponent,[i6.ToastsManager,i1.ViewContainerRef,i7.ErrorHandlerService,
          i8.AppConfig,i1.ElementRef,i1.ApplicationRef,i3.Http],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n']))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,4).sidebarCollapsed;
    const currVal_1:boolean = !i1.ɵnov(_v,4).sidebarCollapsed;
    const currVal_2:boolean = !i1.ɵnov(_v,4).sidebarCollapsed;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2);
  });
}
export function View_AuthenticationWamComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AuthenticationWamComponent_1)),i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i10.AuthenticationWamComponent = _v.component;
    const currVal_0:any = _co.isAuthenticated;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_AuthenticationWamComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'app-authentication-wam',
      ([] as any[]),(null as any),(null as any),(null as any),View_AuthenticationWamComponent_0,
      RenderType_AuthenticationWamComponent)),i1.ɵprd(512,(null as any),i11.UserService,
      i11.UserService,[i8.AppConfig]),i1.ɵdid(114688,(null as any),0,i10.AuthenticationWamComponent,
      [i12.AuthenticationWamService,i13.ActivatedRoute,i13.Router,i3.Http,i11.UserService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const AuthenticationWamComponentNgFactory:i1.ComponentFactory<i10.AuthenticationWamComponent> = i1.ɵccf('app-authentication-wam',
    i10.AuthenticationWamComponent,View_AuthenticationWamComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvUEJBQkg3L1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9hdXRoZW50aWNhdGlvbi13YW0vYXV0aGVudGljYXRpb24td2FtLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9QQkFCSDcvV29ya3NwYWNlL09uUHJlbUNoaW5hL1BhY2tJVFdlYkd1aS9zcmMvYXBwL2F1dGhlbnRpY2F0aW9uLXdhbS9hdXRoZW50aWNhdGlvbi13YW0uY29tcG9uZW50LnRzIiwibmc6Ly8vQzovVXNlcnMvUEJBQkg3L1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9hdXRoZW50aWNhdGlvbi13YW0vYXV0aGVudGljYXRpb24td2FtLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvUEJBQkg3L1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9hdXRoZW50aWNhdGlvbi13YW0vYXV0aGVudGljYXRpb24td2FtLmNvbXBvbmVudC50cy5BdXRoZW50aWNhdGlvbldhbUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgKm5nSWYgPWlzQXV0aGVudGljYXRlZD5cclxuXHJcbjxhcHAtaG9tZT48L2FwcC1ob21lPlxyXG5cclxuPC9kaXY+IiwiPGFwcC1hdXRoZW50aWNhdGlvbi13YW0+PC9hcHAtYXV0aGVudGljYXRpb24td2FtPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQTRCO2FBQUEsMEJBRTVCO01BQUE7VUFBQTttQkFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBO21DQUFBLDBDQUFBO01BQUE7OERBQUE7TUFBcUI7SUFBckI7SUFBQTtJQUFBO0lBQUEsV0FBQSw2QkFBQTs7OztvQkFGQTtNQUFBLDJDQUFBO29CQUFBOztJQUFLO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0FBO01BQUE7MkNBQUE7c0JBQUEsdUJBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/authentication-wam/authentication-wam.component.ngfactory.ts